export default "__VITE_ASSET__Be7JRB6u__"